import * as React from 'react'
import * as _ from 'lodash'
import moment from 'moment'

import { ISearchContext, FilterParameterTypeString, ISearchFilter } from '../../global/models/search-context';
import { ISearchField, SearchOperator } from '../models/search-field';
import { ReactNode } from 'react-redux';
import { SearchContext } from './search-context';
import { DropdownSelect } from '../../global/components/inputs/selects/dropdown-select';
import { SearchFilter } from './search-filter';
import { IEpiProps } from '../models/epi-props';

interface IProps {
    epiProps: IEpiProps

    // The current search field data to display
    searchField: ISearchField;
    /** The filters available under the current context */
    searchFilters: ISearchFilter[];
    // name of search field
    name: string;

    // Callback for when the search field is changed
    onChange: (searchField: ISearchField) => void;
    // Callback for when remove is pressed
    onRemove: () => void;
    onKeyDown: (e: any) => void;
}

interface IState {

}

/**
 * XXX: A lot of this class is copied into search-context. Careful making changes
 */
export class SearchOperatorView extends React.Component<IProps, IState> {



    render() {
        const { searchFilters, searchField } = this.props;
        let className = 'advanced-search-field';

        if (!searchField.valid) {
            className += ' advanced-search-field--invalid';
        }

        return (
            <div className={className}>
                <div className="field-inputs">

                    <DropdownSelect
                        name={`${this.props.name}-operator`}
                        values={Object.keys(SearchOperator).map(this.formatSearchOperator)}
                        onDropdownSelect={this.onOperaterChange} />

                    <SearchFilter
                        name={this.props.name}
                        epiProps={this.props.epiProps}
                        searchField={this.props.searchField}
                        searchFilters={this.props.searchFilters}
                        onKeyDown={this.props.onKeyDown}
                        onChange={this.props.onChange} />

                </div>
                <button type="button" onClick={this.handleRemove} className="icon-button">
                    <svg className="remove-field">
                        <use xlinkHref="#icon-substract"></use>
                    </svg>
                </button>
            </div>
        );
    }

    handleRemove = (e) => {
        e.preventDefault();
        this.props.onRemove();
    }

    // format dropdown options for the operator (e.g. And Or Not Exactly)
    formatSearchOperator = (operator: string, index: number) => {
        const { searchField } = this.props;
        return {
            id: index.toString(),
            display: operator,
            selected: operator === searchField.operator.toString()
        }
    }

    // Update the operator
    onOperaterChange = (id: string) => {
        const searchField = {
            ...this.props.searchField,
            operator: Object.keys(SearchOperator)[parseInt(id)]
        } as ISearchField

        this.props.onChange(searchField)
    }
}